import React, { MouseEvent, ReactNode, useContext } from 'react';
import cn from "classnames";

import './ButtonDropdownItem.scss';
import { ButtonDropdownContext } from '../ButtonDropdown/ButtonDropdown';

export interface IButtonDropdownItemProps {
    className?: string,
    children?: ReactNode,
    onClick?: (e: MouseEvent) => void
}

export function ButtonDropdownItem({
    className,
    children,
    onClick,
}: IButtonDropdownItemProps) {
    const ctx = useContext(ButtonDropdownContext)

    // Close dropdown on item click, if the item didn't prevent default.
    function onClickInternal(e: MouseEvent) {
        onClick(e);
        if (!e.defaultPrevented) {
            ctx.close();
        }
    }

    return <div className={cn('buttonDropdownItem', className)} onClick={onClickInternal}>
        {children}
    </div>
}